import { format } from '../../../../utils';
const getDirectionDateLabel = (segments = []) => {
    var _a, _b, _c;
    const departure = (_a = segments[0]) === null || _a === void 0 ? void 0 : _a.departure;
    const arrival = (_b = segments[segments.length - 1]) === null || _b === void 0 ? void 0 : _b.arrival;
    if (!(departure === null || departure === void 0 ? void 0 : departure.date)) {
        return null;
    }
    return `${format(departure.date, 'd MMM, EEEEEE')} • ${departure.time} — ${(_c = arrival === null || arrival === void 0 ? void 0 : arrival.time) !== null && _c !== void 0 ? _c : ''}`;
};
export const splitByDirection = (items, segmentGroups) => {
    var _a;
    const passengersCount = new Set(items.map(item => item.passengerName)).size;
    const directionsCount = passengersCount ? items.length / passengersCount : 0;
    const isSplittable = Number.isInteger(directionsCount) && directionsCount > 1 && directionsCount <= segmentGroups.length;
    if (!isSplittable) {
        return [{ key: 'all', dateLabel: getDirectionDateLabel((_a = segmentGroups[0]) === null || _a === void 0 ? void 0 : _a.segments), items }];
    }
    return Array.from({ length: directionsCount }, (_, index) => ({
        key: segmentGroups[index].groupId,
        dateLabel: getDirectionDateLabel(segmentGroups[index].segments),
        items: items.slice(index * passengersCount, (index + 1) * passengersCount)
    }));
};
